/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsCustomTimeScaleRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsCustomTimeScaleRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import CustomReports, { LazyServicedeskReportsCustom } from './ui/custom/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReportsCustomTimeScaleRouteEntry: Route = createEntry(
	servicedeskReportsCustomTimeScaleRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomReports,
		perfMetricKey: 'service-management.reports.custom',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsCustom],
		ufoName: 'service-management-custom-reports',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
